import React, { useState } from 'react';
import { Popover, Button, Tabs } from 'antd';
import Tooltip from './Tooltip';
import DuotoneLightIcon from './DuotoneLightIcon';
import { AddVariableInContentTextRichEditor } from '../RichEditor/utils';
import { twemojiCategories } from '../../utils/twemojiList';
import { EditorState, Modifier, RichUtils } from 'draft-js';
import './EmojiPicker.less';


const EmojiPicker = ({ editorState, setEditorState, tooltipContent = "Emojis" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('Visages et émotions');

  const handleEmojiClick = (emoji) => {
    // Récupérer la taille de police actuelle
    const currentInlineStyle = editorState.getCurrentInlineStyle(editorState.getSelection());
    let currentFontSize = null;

    currentInlineStyle.forEach(style => {
      if (style.startsWith('FONT_SIZE_')) {
        const match = style.match(/FONT_SIZE_(\d+)/);
        if (match) {
          currentFontSize = parseInt(match[1], 10);
        }
      }
    });

    // Insérer l'emoji
    let newEditorState = AddVariableInContentTextRichEditor(editorState, emoji);

    // Si une taille de police spécifique est détectée, l'appliquer à l'emoji
    if (currentFontSize) {
      const selection = newEditorState.getSelection();
      const startOffset = selection.getStartOffset() - emoji.length;
      const endOffset = selection.getStartOffset();

      const newSelection = selection.merge({
        anchorOffset: startOffset,
        focusOffset: endOffset,
      });

      newEditorState = RichUtils.toggleInlineStyle(
        EditorState.forceSelection(newEditorState, newSelection),
        `FONT_SIZE_${currentFontSize}`
      );
    }

    setEditorState(newEditorState);
    setIsOpen(false);
  };

  const emojiGrid = (
    <div
      style={{ width: '400px', maxHeight: '400px' }}
      // preventDefault, comme la barre de style flottante (FloatyStylingWrapper) :
      // sans lui le mousedown donne le focus au bouton, l'éditeur perd le sien et
      // la cellule de tableau qu'on édite enregistre son texte au blur, puis se
      // reconstruit depuis le store — curseur remis en tête, emoji en début de
      // ligne. Le picker est rendu dans un portail, il ne profite pas du
      // preventDefault du panneau d'insertion.
      onMouseDown={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Tabs
        activeKey={activeTab}
        onChange={(key) => {
          setActiveTab(key);
        }}
        size="small"
        style={{ padding: '8px' }}
        popupClassName="emoji-picker-tabs-more-dropdown"
        onMouseDown={(e) => {
          // Empêcher la fermeture du popover lors du clic sur les onglets
          if (e.target.closest('.ant-tabs-tab') || e.target.closest('.ant-tabs-dropdown')) {
            e.stopPropagation();
          }
        }}
        items={Object.keys(twemojiCategories).map(category => ({
          key: category,
          label: category,
          children: (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(10, 1fr)',
              gap: '4px',
              padding: '8px',
              maxHeight: '320px',
              overflowY: 'auto'
            }}>
              {twemojiCategories[category].map((emoji, index) => (
                <Button
                  key={`${category}-${index}`}
                  type="text"
                  size="small"
                  style={{
                    width: '32px',
                    height: '32px',
                    padding: 0,
                    fontSize: '18px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid #d9d9d9',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    backgroundColor: 'white',
                    fontFamily: 'Arial Unicode MS, Segoe UI Symbol, Apple Symbols, Noto Sans Symbols, Arial, sans-serif'
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEmojiClick(emoji);
                  }}
                >
                  {emoji}
                </Button>
              ))}
            </div>
          )
        }))}
      />
    </div>
  );

  return (
    <Tooltip
      open={tooltipVisible}
      placement='bottom'
      mouseLeaveDelay='0'
      title={tooltipContent}
    >
      <Popover
        content={emojiGrid}
        title="Sélectionner un emoji"
        trigger="click"
        open={isOpen}
        onOpenChange={(visible) => {
          setIsOpen(visible);
          if (!visible) {
            setActiveTab('Visages et émotions');
          }
        }}
        placement="bottom"
        rootClassName="emoji-picker-popover"
        destroyTooltipOnHide={false}
        styles={{ body: { pointerEvents: 'auto' } }}
      >
        <Button
          type="text"
          size="small"
          style={{
            width: '32px',
            height: '32px',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid #d9d9d9',
            borderRadius: '5px',
            backgroundColor: 'white',
            marginRight: '2px'
          }}
          onMouseEnter={() => setTooltipVisible(true)}
          onMouseLeave={() => setTooltipVisible(false)}
        >
          <DuotoneLightIcon name='face-smile' weight='solid' style={{ fontSize: 18, color: 'black' }} />
        </Button>
      </Popover>
    </Tooltip>
  );
};

export default EmojiPicker;
